import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { Renderable } from '@adornis/chemistry/renderable.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

/**
 * @customElement board-component-user-count-stats
 */
@customElement('board-component-user-count-stats')
export class BoardComponentUserCountStats extends ChemistryLitElement {
  @property({ type: Boolean }) loading = false;
  @property({ attribute: false }) elements: Record<string, Renderable> = {};

  override render() {
    return html`<cr-card space="sm" horizontal>
      <cr-flex
        flex
        horizontal
        space="md"
        padding="sm"
        crossaxis-center
        end
        ${css({
          backgroundColor: 'white',
          borderRadius: '15px',
        })}
      >
        ${!this.loading
          ? repeat(
              Object.keys(this.elements),
              k => k,
              k => {
                return html`<cr-flex horizontal space="sm">
                  <cr-text bold>${k}</cr-text>
                  <cr-text>${this.elements[k]}</cr-text>
                </cr-flex>`;
              },
            )
          : html` <cr-loader ${css({ height: '12px', width: '12px' })}></cr-loader>`}
      </cr-flex>
    </cr-card>`;
  }
}
